import Button from '../../../../../../../../../../../../components/button';
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {
	putHiddenFields,
	isHiddenFieldsUpdating as setIsHiddenFieldsUpdating,
	hiddenFieldsUpdate as setHiddenFieldsUpdate,
	getSharingDetailsPopup, isHiddenFieldsChanging
} from '../../../../../../../../../../../../../actions/sharingDetailsActions';
import Icon from '../../../../../../../../../../../../components/icon';
import {isUpgradeToBusinessPopup} from '../../../../../../../../../../../../../actions/popupActions';
import {msgSharingDetailsBar} from '../../../../../../../../../../../../../actions/msgBarActions';

function SaveHiddenFieldsChanges() {

	const {t} = useTranslation();
	const dispatch = useDispatch();

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const selectedCollaborator = useSelector(state => state.sharingDetailsReducer.selectedCollaborator);
	const hiddenFieldsUpdate = useSelector(state => state.sharingDetailsReducer.hiddenFieldsUpdate);
	const isHiddenFieldsUpdating = useSelector(state => state.sharingDetailsReducer.isHiddenFieldsUpdating);
	const hasTheBusinessPermission = useSelector(state => state.permissionReducer.hasTheBusinessPermission);
	const profile = useSelector(state => state.profileReducer.getProfile);
	const sharingDetailsPopup = useSelector(state => state.sharingDetailsReducer.getSharingDetailsPopup);

	const cancelHiddenFieldsChange = () => {
		dispatch(setHiddenFieldsUpdate(selectedCollaborator.hiddenFields));
	};

	const saveHiddenFieldsChange = () => {
		if(!hasTheBusinessPermission) {
			dispatch(getSharingDetailsPopup([]));
			dispatch(isHiddenFieldsChanging(false));
			setTimeout(() => {
				dispatch(isUpgradeToBusinessPopup(true));
			}, 250);

			return;
		}

		/*
		* If BUSINESS but betaVersion is equals to NONE
		* */

		if(profile.betaVersion !== "HIDDEN_FIELD_V1"){
			dispatch(msgSharingDetailsBar(['error', 'HIDDEN_FIELD_V1 rights required.']));
			dispatch(isHiddenFieldsChanging(false));
			dispatch(setIsHiddenFieldsUpdating(false));
			return;
		}

		dispatch(setIsHiddenFieldsUpdating(true));
		dispatch(putHiddenFields({
			"groupId" : sharingDetailsPopup[2] ? sharingDetailsPopup[2] : selectedContactsGroup.id,
			"ownerId" : selectedContactsGroup.ownerId,
			"targetId" : selectedCollaborator.id,
			"targetType" : selectedCollaborator.type,
			"hiddenFields" : hiddenFieldsUpdate
		}))
	};

	return (
		<div className="options-wrapper">
			<div className="options d-flex align-items-center justify-content-end collapsed">
				<div className={`btn-wrapper`}>
					<Button
						className="btn-outline-primary"
						onClick={cancelHiddenFieldsChange}
					>
						{t("textCancel")}
					</Button>
					<Button
						className="ml-2 btn-primary"
						onClick={saveHiddenFieldsChange}
					>
						{
							isHiddenFieldsUpdating
							?
								<Icon animated={'pulse'} name="spinner"/>
							:
								t("textSave")
						}
					</Button>
				</div>
			</div>
		</div>
	)
}

export default SaveHiddenFieldsChanges;
